import { usePut } from '../../HttpClient';
import { useMutationWithErrorHandling } from '../../../hooks/UseMutationWithErrorHandling';

export function useRemoveAccountTreatment() {
  const put = usePut(true, "ams");
  const removeAccountTreatment = (accountId: string, treatmentId: string) => {
    return put(`/api/proxy/ams/account-service/account/${accountId}/remove-treatment`, {
        accountTreatmentId: treatmentId,
    });
  };

  return useMutationWithErrorHandling({
    mutationFn: ({ accountId, treatmentId,}: { accountId: string, treatmentId: string}) =>
      removeAccountTreatment(accountId, treatmentId),
  });
}
